<template>
    <div>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <span>Backup DB</span>
            <div>
              <span class="mr-2">{{ "último: " }}</span>
              <span class="primary--text">{{ lastBackup }}</span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="justify-center align-center">
              <v-btn small color="primary" rounded @click="saveBackup()">fazer backup</v-btn>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-snackbar v-model="alert" multi-line color="accent" :timeout="2000">
        {{ msg }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="alert = false">
            X
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </template>
  
  <script>
  export default {
    name: "backup-db",
    computed: {
    backup() {
        return this.$store.getters.backup;
      },
      lastBackup(){
        return this.$store.getters.lastBackup;
      }
    },
    watch: {
      backup(b) {
        if (b){
          this.showAlert(b)
          this.$store.dispatch("setLastBackup", b)
        }
      }
    },
    created() {
      this.$store.dispatch('loadLastBackup')
    },
    mounted() {
      this.precos = this.precosCm2
    },
    data() {
      return {
        alert: false,
        msg: ""
      }
    },
    methods: {
      saveBackup() {
        this.$store.dispatch("resetBackup")
        this.$store.dispatch("saveBackup")
      },
      showAlert(m) {
          this.msg = m;
          this.alert = true;
        },
    },
  };
  </script>
